import React from 'react';

import Typography from '@ui/Typography';

import Cms from '@components/Cms/Cms';

const RecaptchaInfo = () => {
    return (
        <Typography component="div" color="text.secondary" sx={{ marginY: 4 }}>
            <Cms cmsId={392} html className="recaptcha-info" />
        </Typography>
    );
};

export default RecaptchaInfo;
